import React from 'react'
import BackButton from './BackButton'
import ThemeToggleButton from '../ThemeToggleButton'
import './PageHeader.css'

// Unified header for august's six primary screens (Today, Journey, Tracklist, Moments,
// Profile, Gratitude) — design system refresh, precision pass. Three fixed rows: Row 1 is a
// single rail (left control | centered eyebrow | right control), Row 2 is the Signatural
// title, Row 3 is the optional descriptor. Row 2/3 are left-aligned with page content below;
// Row 1's eyebrow is centered between the two control slots — a deliberate mismatch, per the
// reference mock, not something to "fix" into one alignment. The component owns all vertical
// spacing (PageHeader.css's --header-* tokens) — pages supply content only, no page-specific
// margin-top values.

export function Eyebrow({ children }) {
  if (!children) return null
  return <div className="ph-eyebrow">{children}</div>
}

// Long titles ("What Have You Received?", "Turn Doing Into Gratitude") get a smaller display
// size than short ones ("Gratitude", "Journey", "Practices") — premium-refinement pass. Opt-in
// by construction: the threshold only ever adds a modifier class, so every title shorter than
// it (every current title on Today/Journey/Practices/Moments/Profile, and every short Practice
// Flow step title) renders exactly as before. Character count, not word count — Signatural is a
// wide cursive display face, so rendered width tracks characters more directly than word count.
// 16 was picked so "Best Thing Today" (16) still gets the large size (short/punchy, reads like
// "Gratitude") while "What Have You Received?" (23) and "Turn Into Gratitude" (19) — the actual
// cramped cases — get the smaller one.
const LONG_TITLE_THRESHOLD = 16

export function ScriptTitle({ children }) {
  const isLong = typeof children === 'string' && children.length > LONG_TITLE_THRESHOLD
  return <div className={`ph-title${isLong ? ' ph-title--long' : ''}`}>{children}</div>
}

export function PageDescriptor({ children }) {
  if (!children) return null
  return <div className="ph-descriptor">{children}</div>
}

export default function PageHeader({
  eyebrow, title, descriptor,
  showBack, onBack,
  showTheme = true, augustTheme, onAugustThemeChange,
}) {
  return (
    <div className="ph-wrap">
      <div className="ph-row1">
        <div className="ph-row1-left">
          {showBack && <BackButton onClick={onBack} />}
        </div>
        <div className="ph-row1-center">
          <Eyebrow>{eyebrow}</Eyebrow>
        </div>
        <div className="ph-row1-right">
          {showTheme && <ThemeToggleButton augustTheme={augustTheme} onAugustThemeChange={onAugustThemeChange} />}
        </div>
      </div>
      <ScriptTitle>{title}</ScriptTitle>
      <PageDescriptor>{descriptor}</PageDescriptor>
    </div>
  )
}
